import Icon from '@xo-union/tk-component-icons';
import React, { useContext } from 'react';
import { PhotoGalleryItem } from '../Card';
import { useHistory } from 'react-router-dom';

import styles from './photoGallery.scss';
import { ItemProps } from './common';
import { PhotoTimelineItemsFragment } from '../../generated/graphql';
import { TrackingContext } from '../../TrackingContext';
import { photoTimelineItemRoute } from '../../helpers/routes';
import { resizeImageW } from '../../helpers/mediaApiUrls';

const PhotoTimeline: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const gallery = item as PhotoTimelineItemsFragment;
  const photos = gallery.photoItems.map(photo => ({
    ...photo,
    mediaUrl: resizeImageW(photo.mediaUrl, 220),
  }));
  const history = useHistory();
  const { track } = useContext(TrackingContext);

  const openPhotoGalleryEdit = () => {
    track('Item Action Initiated', {
      action: 'edit',
      actionName: 'Edit Page Item',
      page: page.title,
      item: item.type,
    });
    history.push(photoTimelineItemRoute(page.id, gallery.id, preview));
  };

  const rightElement = (
    <div className={styles.editContainer}>
      <Icon name="edit" size="md" />
      <span>Edit Timeline</span>
    </div>
  );

  return (
    <PhotoGalleryItem
      captionText="Photo Timeline"
      onClick={openPhotoGalleryEdit}
      photoItems={photos}
      className={className}
      rightElement={rightElement}
      data-testid={`photo-timeline-item-${gallery.id}`}
      {...dragProps}
    />
  );
};

export default PhotoTimeline;
